import { SelectGroup } from "@/components/ui/select";

export function PartUsageFields({ currentExport, data, setData }) {
  if (currentExport == "part usage") {
    return (
      <>
        <SelectGroup
          label="Ticket Type"
          menuPosition="fixed"
          isClearable
          placeholder="Select Ticket Type"
          className="w-full"
          options={[
            { label: "PRT", value: "PRT" },
            { label: "RRT", value: "RRT" },
          ]}
          value={[
            { label: "PRT", value: "PRT" },
            { label: "RRT", value: "RRT" },
          ].filter((option) => option.value === data.part_usage_ticket_type)}
          onChange={(e) => {
            setData({
              ...data,
              export_type: null,
              part_usage_ticket_type: e ? e.value : null,
            });
          }}
        />
        <SelectGroup
          label="Part Type"
          menuPosition="fixed"
          isClearable
          placeholder="Select Part Type"
          className="w-full"
          options={[
            { label: "Repairable", value: "repairable" },
            { label: "Non Repairable", value: "non_repairable" },
          ]}
          value={[
            { label: "Repairable", value: "repairable" },
            { label: "Non Repairable", value: "non_repairable" },
          ].filter((option) => option.value === data.part_type)}
          onChange={(e) => {
            setData({
              ...data,
              export_type: null,
              part_type: e ? e.value : null,
            });
          }}
        />
      </>
    );
  }
  return null;
}
